import 'slick-carousel';

const $offers1 = $('.offers1-card-slider');
const $offers2 = $('.offers2-card-slider');
const $offers3 = $('.offers3-card-slider');

$offers1.slick({
    variableWidth: true,
    prevArrow: '.offers-slider-nav1 .ic-button-arrow-prev',
    nextArrow: '.offers-slider-nav1 .ic-button-arrow-next',
    mobileFirst: true,
    lazyLoad: 'progressive',
    responsive: [
        {
            breakpoint: 767,
            settings: {
                centerMode: true,
            },
        },
    ],
});

$offers2.slick({
    variableWidth: true,
    prevArrow: '.offers-slider-nav2 .ic-button-arrow-prev',
    nextArrow: '.offers-slider-nav2 .ic-button-arrow-next',
    mobileFirst: true,
    lazyLoad: 'progressive',
    responsive: [
        {
            breakpoint: 767,
            settings: {
                centerMode: true,
            },
        },
    ],
});

$offers3.slick({
    variableWidth: true,
    prevArrow: '.offers-slider-nav3 .ic-button-arrow-prev',
    nextArrow: '.offers-slider-nav3 .ic-button-arrow-next',
    mobileFirst: true,
    lazyLoad: 'progressive',
    responsive: [
        {
            breakpoint: 767,
            settings: {
                centerMode: true,
            },
        },
    ],
});

console.log('***********************************************************************************************************');
